import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Wand2, ArrowRight, Sparkles } from "lucide-react";

export default function AITools() {
  const [tools, setTools] = useState([]);

  useEffect(() => {
    api.get("/ai-tools").then((r) => setTools(r.data));
  }, []);

  const grouped = tools.reduce((acc, t) => {
    (acc[t.category] = acc[t.category] || []).push(t);
    return acc;
  }, {});

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <section className="py-20 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-4">AI Tools</div>
            <h1 className="font-display text-5xl md:text-6xl leading-tight">Write, pitch, respond — <span className="italic text-brand-pink">in seconds</span>.</h1>
            <p className="mt-6 text-neutral-600 max-w-2xl text-lg">
              Trained on Kristy's real playbooks. Every tool below produces on-brand, high-converting copy for hosts.
            </p>
          </div>
          <div className="lg:col-span-4 rounded-3xl bg-neutral-950 text-white p-8 flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-brand-pink/20 flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-brand-pink" />
            </div>
            <div>
              <div className="font-display text-lg">Powered by Claude Sonnet 4.5</div>
              <div className="text-sm text-white/60">The most nuanced writing model, tuned for hosts.</div>
            </div>
          </div>
        </div>

        <div className="mt-16 space-y-14">
          {Object.entries(grouped).map(([cat, ts]) => (
            <div key={cat}>
              <div className="flex items-center gap-3 mb-6">
                <div className="text-xs uppercase tracking-widest text-brand-pink">{cat}</div>
                <div className="h-px flex-1 bg-neutral-200" />
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {ts.map((t) => (
                  <Link
                    key={t.id}
                    to={`/ai-tools/${t.id}`}
                    data-testid={`ai-tool-${t.id}`}
                    className="group rounded-3xl border border-neutral-100 p-6 bg-white card-soft hover:-translate-y-1 hover:border-brand-pink/40 transition-all flex flex-col"
                  >
                    <div className="w-11 h-11 rounded-2xl bg-brand-blush flex items-center justify-center mb-4">
                      <Wand2 className="w-5 h-5 text-brand-pink" />
                    </div>
                    <div className="font-display text-lg mb-1">{t.name}</div>
                    <div className="text-sm text-neutral-500 flex-1">Generate a tailored output using Kristy's frameworks.</div>
                    <div className="mt-4 text-sm inline-flex items-center gap-1 text-brand-pink font-medium">
                      Open tool <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
